export default __webpack_public_path__ + "static/media/cash_register.8e3849c6.mp3";